import React from "react";

export const TextBlockWidget = ({ config = {} }) => (
  <div
    className="sb-card sb-textblock"
    style={{
      textAlign: config.align || "center",
      fontSize: `${(config.fontScale || 1) * 2}vw`,
    }}
  >
    {config.text || ""}
  </div>
);

export const ImageWidget = ({ config = {} }) =>
  config.url ? (
    <img
      className="sb-image"
      src={config.url}
      alt={config.alt || ""}
      style={{ objectFit: config.fit || "contain", width: "100%", height: "100%" }}
    />
  ) : (
    <div className="sb-card sb-image-empty">No image URL</div>
  );

export const SpacerWidget = ({ config = {} }) =>
  config.divider ? <div className="sb-divider" /> : <div className="sb-spacer" />;

// Rich-text announcement authored in the designer (tiptap HTML).
export const AnnouncementsWidget = ({ config = {} }) => (
  <div className="sb-card sb-announce">
    <div
      className={`sb-announce-body${config.scroll ? " scroll" : ""}`}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: config.html || "" }}
    />
  </div>
);

// Fallback for widget types not yet implemented on this board build.
export const PlaceholderWidget = ({ config = {}, widgetType }) => (
  <div className="sb-card sb-placeholder">
    <div className="sb-placeholder-label">{widgetType || "Widget"}</div>
    <div className="sb-placeholder-sub">Coming soon</div>
  </div>
);
